import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`


  query formTemplateVersionsByTemplateId($organizationId: UUID!,$templateId: UUID!) {
    formTemplateVersionsByTemplateId(organizationId: $organizationId,templateId: $templateId)  {
      template_id
      version
      content, 
      created_ts
      created_by
    }
}
`;



export function apiGetFormTemplateVersionsByTemplateId(organizationId, templateId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        if(!organizationId) reject("templateId is required");
        client
            .query({
                query: query,
                variables: {organizationId, templateId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.formTemplateVersionsByTemplateId);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get form templates");
                reject(err); // R
            })
    });
}
